var Backbone = require('backbone');
var _ = require('underscore');

require('./Closed.less');


module.exports = Backbone.View.extend({

    el: '.Closed',

    events: {
    },


    initialize: function () {
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Closed/Closed.js
// module id = 103
// module chunks = 0